module.exports = __webpack_public_path__ + "img/buenos_aires_san_telmo.d4a87edd.jpg";